module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEW YORK UNIVERSITY PRESS")]), _c('br'), _vm._v("New York and London"), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.nyupress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nyupress.org")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 2010 by New York University"), _c('br'), _vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("Race, ethnicity, and policing : new and essential readings /"), _c('br'), _vm._v("edited by Stephen K. Rice and Michael D. White."), _c('br'), _vm._v("p. cm."), _c('br'), _vm._v("Includes bibliographical references and index."), _c('br'), _vm._v("ISBN-13: 978-0-8147-7615-5 (cl : alk. paper)"), _c('br'), _vm._v("ISBN-10: 0-8147-7615-9 (cl : alk. paper)"), _c('br'), _vm._v("ISBN-13: 978-0-8147-7616-2 (pb : alk. paper)"), _c('br'), _vm._v("ISBN-10: 0-8147-7616-7 (pb : alk. paper)"), _c('br'), _vm._v("1. Racial profiling in law enforcement. 2. Police—Attitudes."), _c('br'), _vm._v("3. Crime and race. I. Rice, Stephen K. II. White, Michael D."), _c('br'), _vm._v("(Michael Douglas), 1951 –"), _c('br'), _vm._v("HV7936.R3R29 2010"), _c('br'), _vm._v("363.2′3089—dc22           2009039286")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("New York University Press books are printed on acid-free paper,"), _c('br'), _vm._v("and their binding materials are chosen for strength and durability."), _c('br'), _vm._v("We strive to use environmentally responsible suppliers and materials"), _c('br'), _vm._v("to the greatest extent possible in publishing our books.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("c   10 9 8 7 6 5 4 3 2 1"), _c('br'), _vm._v("p   10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8422d616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0